import React, {Fragment, useEffect} from 'react';
import Banner from '../components/banner';
import DotSection from '../components/dot-section';
import Lottie from 'react-lottie'
import animationData from './checkmark-lottie.json'
import Questions from '../components/questions/index';
import Footer from '../components/footer';
import '../scss/homepage.scss';

const Homepage = (props) => {

    const partnersTitle = 'We\'ll find the right lending partner for you!'

    const checkmarkOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };


    const moveTextSmall = () => {
        let slidingText = document.querySelectorAll('.slide-text-small');
        // see where the window is
        slidingText.forEach(element => {
            let topPos = element.getBoundingClientRect().top + window.scrollY;
            let diff = (window.scrollY - topPos) + 400;
            if (diff > 0 && diff < 600) {
                let limit = diff * .04;
                if (limit > 12) {
                    limit = 12;
                    element.style.marginTop = `-${limit}%`;
                } else {
                    element.style.marginTop = `-${limit}%`;
                }
            }
        })
    };

    window.addEventListener('scroll', moveTextSmall);

    const moveTextLarge = () => {
        let slidingText = document.querySelectorAll('.slide-text-large');
        // see where the window is
        slidingText.forEach(element => {
            let topPos = element.getBoundingClientRect().top + window.scrollY;
            let diff = (window.scrollY - topPos) + 400;
            if (diff > 0 && diff < 600) {
                let limit = diff * .04;
                if (limit > 40) {
                    limit = 40;
                    element.style.marginTop = `-${limit}%`;
                } else {
                    element.style.marginTop = `-${limit}%`;
                }
            }
        })
    };

    window.addEventListener('scroll', moveTextLarge);

    const readProperty = (name) => {
        const sassArray = window.getComputedStyle(document.body).getPropertyValue('--' + name).split(",");
        const nameArray = sassArray.map(n => n.substring(n.indexOf("\"") + 1, n.lastIndexOf("\"")));
        return nameArray.map((val, i) => {
            return <Fragment key={i}>
                <div data-alt={val.substring(val.lastIndexOf("/") + 1, val.indexOf("_"))}
                     data-img-src={val.replace('../assets', '')}/>
            </Fragment>
        })

    }


    return (
        <>
            <div className="homepage-container">
                <Banner config={props.config}/>
                <div className="loans-for-you">
                    <div className="section-title_text">
                        Loans Created Specifically for <span className="break-desktop">You and Your Needs.</span>
                    </div>
                    <div className="loan-checks">
                        <div className="check-item">
                            <div style={{width: '40px', height: '40px'}} className="animated-checkmark">
                                <Lottie options={checkmarkOptions}
                                        height={40}
                                        width={40}
                                />
                            </div>
                            <div className="check-text">
                                Rates as low as 4.99% based on your credit profile.
                            </div>
                        </div>
                        <div className="check-item">
                            <div style={{width: '40px', height: '40px'}} className="animated-checkmark">
                                <Lottie options={checkmarkOptions}
                                        height={40}
                                        width={40}
                                />
                            </div>
                            <div className="check-text">
                                Terms from 24 months to 84 months with no prepayment fees.
                            </div>
                        </div>
                        <div className="check-item">
                            <div style={{width: '40px', height: '40px'}} className="animated-checkmark">
                                <Lottie options={checkmarkOptions}
                                        height={40}
                                        width={40}
                                />
                            </div>
                            <div className="check-text">
                                Checking your offers is free and will not impact your credit score.
                            </div>
                        </div>
                        <div className="check-item">
                            <div style={{width: '40px', height: '40px'}} className="animated-checkmark">
                                <Lottie options={checkmarkOptions}
                                        height={40}
                                        width={40}
                                />
                            </div>
                            <div className="check-text">
                                SSL security and 256-bit encryption to safeguard your information.
                            </div>
                        </div>
                    </div>
                    <div className="partners">
                        <div className="partners__title">
                            {partnersTitle}
                        </div>
                        <div className="partners__logos">
                            {
                                readProperty('define')
                            }
                        </div>
                    </div>
                </div>
            </div>
            <DotSection config={props.config}/>
            <Questions config={props.config}/>
            <Footer config={props.config}/>

        </>
    );
};

export default Homepage;
